import React from "react";

const SvgBBiconsCheck = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <g data-name="Obecn\xE9 ikony">
      <path d="M92 157.29a8.9 8.9 0 01-5.11-1.61 9 9 0 01-2.28-12.52l64.44-93a9 9 0 0114.8 10.25l-64.49 93a9 9 0 01-7.36 3.88z" />
      <path d="M92 157.28a8.94 8.94 0 01-6.36-2.63l-50.97-50.93A9 9 0 1147.4 91l50.92 50.93A9 9 0 0192 157.28z" />
    </g>
  </svg>
);

export default SvgBBiconsCheck;

